import React, { useEffect, createElement } from "react";
import makeStyles from "@mui/styles/makeStyles";

import { useDispatch, useSelector } from "react-redux";
import { isBlank } from "../../util/ext";
import { logOut } from "../../auth/authActions";
import { pipe } from "ramda";
import { hasAdminRole, hasCreatorManagerRole } from "../../auth/authUtils";

import Container from "@mui/material/Container";

import Unauthorized from "../../auth/Unauthorized";
import ModuleAdminView from "./ModuleAdminView";
import ModuleCreatorManagerView from "./ModuleCreatorManagerView";

const useStyles = makeStyles(theme => ({
  panel: {
    display: "flex",
    flexDirection: "column",
    height: "95%",
    padding: "0",
    border: "3px solid white",
    background: "white",
    borderRadius: "20px",
  },
}));

const UnauthorizedAccess = () => {
  return (
    <Unauthorized message="You do not have the proper access rights to the Creator Application" />
  );
};

const setView = auth => {
  if (isBlank(auth.currentOrganization) && hasAdminRole(auth.user)) {
    return ModuleAdminView;
  } else if (hasCreatorManagerRole(auth.currentOrganization)) {
    return ModuleCreatorManagerView;
  } else {
    return UnauthorizedAccess;
  }
};

const ModuleView = () => {
  const classes = useStyles();

  const reduxDispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  useEffect(() => {
    if (isBlank(auth)) {
      reduxDispatch(logOut());
    }
  }, [auth, reduxDispatch]);

  return (
    <Container
      id="modules-view"
      maxWidth={false}
      classes={{ root: classes.panel }}
    >
      {pipe(setView, ele => createElement(ele))(auth)}
    </Container>
  );
};

export default ModuleView;
